//#region src/utils/colorScheme.ts
var e = "uikit-color-scheme", t = "data-theme", n = "themechange", r = "default", i = "system", a = "light", o = "dark", s = (e) => {
	e ? document.documentElement.setAttribute(t, e) : document.documentElement.removeAttribute(t);
}, c = () => decodeURIComponent(document.cookie).split(";").find((t) => t.includes(e))?.split("=")[1], l = () => {
	let e = c();
	switch (e) {
		case r:
			s();
			break;
		case i:
			window.matchMedia("(prefers-color-scheme: dark)").matches ? s(o) : s(a);
			break;
		case a:
		case o: s(e);
	}
	return e;
}, u = (t) => {
	let n = window.location.host.startsWith("localhost") || window.location.host.startsWith("127.0.0.1");
	document.cookie = `${e}=${encodeURIComponent(t)};domain=${n ? "localhost" : ".rio.cloud"};expires=Thu, 18 Dec 2030 12:00:00 UTC;path=/`;
}, d = () => {
	window.addEventListener("message", ({ data: e }) => {
		if (e === "themechange") {
			l();
			for (let e of document.getElementsByTagName("iframe")) e.contentWindow?.postMessage(n, "*");
		}
	}, !1);
};
//#endregion
export { n as THEME_CHANGE_EVENT, o as THEME_DARK, t as THEME_DATA_ATTRIBUTE, r as THEME_DEFAULT, a as THEME_LIGHT, i as THEME_SYSTEM, l as getColorScheme, d as listenForSchemeChange, u as setColorScheme };

//# sourceMappingURL=colorScheme.js.map